import { render } from "./ContentBlockWithImagesAndCaptions.vue?vue&type=template&id=fa54f40c"
import script from "./ContentBlockWithImagesAndCaptions.vue?vue&type=script&lang=js"
export * from "./ContentBlockWithImagesAndCaptions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__